import { axiosInstance } from "./";

const getNotifications = async (params) =>
  await axiosInstance.get(`/service_provider_portal_notifications`, { params });

const setNotificationSeen = async (id) =>
  await axiosInstance.patch(`/service_provider_portal_notifications/${id}`);

export { getNotifications, setNotificationSeen };